import React from 'react'

function AccSysPer() {
  return (
    <head style={{all:'initial'}}>
                <title>مسك دفاتر</title>
                <meta name="description" content="مسك دفاتر شركات"/>
                <meta name="keywords" content="مسك دفاتر" />
            </head>
  )
}

export default AccSysPer